import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';
import './download.css';
import AppStoreIcon from '../../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import GooglePlayIcon from '../../../assets/images/GetItOnGooglePlay_Badge_Web_color_English.png';

const Download: React.FC = () => {
  const qrCodeUrl = process.env.REACT_APP_DOMAIN_URL + '/download';
  const appStoreUrl =
    'https://apps.apple.com/us/app/morph-inspect/id6737966284';
  const googlePlayUrl =
    'https://play.google.com/store/apps/details?id=com.morph_technologies.inspectionapp';

  return (
    <section className="download" id="download">
      <Container>
        <h2 className="download-title">Morph App on App Store / Google Play</h2>
        <p className="download-subtitle">
          Get started with AI-powered inspection reports on your mobile device
        </p>

        <Row className="download-content">
          <Col lg={6} className="qr-section">
            <div className="qr-wrapper">
              <h3 className="qr-title">Quick Mobile Access</h3>
              <div className="qr-code-container">
                <QRCodeSVG
                  value={qrCodeUrl}
                  size={200}
                  level="M"
                  includeMargin={true}
                />
              </div>
              <p className="qr-description">
                Scan with your phone camera to instantly access the app store
              </p>
            </div>
          </Col>

          <Col lg={6} className="badges-section">
            <h3 className="badges-title">Get the App Now</h3>
            <div className="download-badges">
              <a
                href={appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="badge-link"
              >
                <img
                  src={AppStoreIcon}
                  alt="Download on the App Store"
                  className="download-badge app-store-badge"
                />
              </a>
              <a
                href={googlePlayUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="badge-link"
              >
                <img
                  src={GooglePlayIcon}
                  alt="Get it on Google Play"
                  className="download-badge google-play-badge"
                />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Download;
